import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
// import DepositeFilterForm from "@/components/TransactionsPage/TransactionsFilter/DepositeFilterForm/index";
// import ExchangeFilterForm from "@/components/TransactionsPage/TransactionsFilter/ExchangeFilterForm/index";
// import WithdrawFilterForm from "@/components/TransactionsPage/TransactionsFilter/WidthrawFilterForm/index";
import FilterForm from "@/components/TransactionsPage/TransactionsFilter/FilterForm/index";
export default {
  name: "transactions-filter",
  components: {
    // DepositeFilterForm,
    // WithdrawFilterForm,
    // ExchangeFilterForm,
    FilterForm
  },
  props: [],
  data() {
    return {
      drawer: true,
      showDetail: false
    };
  },
  computed: {
    ...mapGetters({
      transactionsDrawer: types.transactions.getters.GET_TRANSACTIONS_DRAWER
    }),
    filtersDrawerState: {
      get() {
        return this.transactionsDrawer;
      },
      set(val) {
        this.transactionsDrawerAction(val);
      }
    },
    getQueryParams() {
      if (Object.entries(this.$route.query).length > 1) {
        Object.entries(this.$route.query).forEach(([key, value]) => {
          if (
            (key === "status" || key === "currency") &&
            !Array.isArray(value)
          ) {
            this.$route.query[key] = [value];
          }
        });
      }
      return this.$route.query;
    }
  },
  mounted() {},
  methods: {
    ...mapActions({
      transactionsDrawerAction:
        types.transactions.actions.ACTION_TRANSACTIONS_DRAWER
    }),
    transactionsDrawerFunc() {
      this.transactionsDrawerAction(!this.transactionsDrawer);
    },
    resetFilters() {
      if (this.$route.query.category) {
        this.$router.replace(
          { query: { category: this.getQueryParams.category } },
          () => {}
        );
      } else {
        this.$router.replace({ query: {} }, () => {});
      }
    }

    // submit() {
    //   this.$refs.form.onSubmit();
    // }
  }
};
